mutation startHoppermationActivation($companyId: ID!) {
  organization: startHoppermationActivation(companyId: $companyId) {
    id
    companyId
    status
  }
}
